import { createApp } from 'vue'
//import App from './App.vue'
import StoreInfoModule from "@/StoreInfoModule.vue";

//createApp(App).mount('#app')
const app = createApp(StoreInfoModule);
app.mount('#store-info-module')
